(() => {
  const selectShade = button => {
    const section = button.closest('[data-c21-shades]');
    if (!section) return;
    section.querySelectorAll('[data-c21-shade]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    const image = section.querySelector('.c21-shades__photo');
    image.removeAttribute('srcset');
    image.src = button.dataset.image;
    image.alt = button.dataset.alt;
    section.querySelector('[data-c21-shade-name]').textContent = button.dataset.name;
    section.querySelector('[data-c21-shade-link]').href = button.dataset.url;
  };
  document.addEventListener('click', event => {
    const accountLink = event.target.closest('a[href*="/customer_authentication/redirect"], a[href="/account/login"]');
    const login = document.getElementById('kp-login-button-header-logo');
    if (accountLink && login) {
      event.preventDefault();
      const drawer = document.querySelector('theme-drawer#cart-drawer[open]');
      Promise.resolve(drawer?.close()).then(() => login.click());
    }
    const swatch = event.target.closest('[data-c21-shade]');
    if (swatch) selectShade(swatch);
    const close = event.target.closest('[data-c21-close]');
    if (close) {
      const details = close.closest('details');
      details.open = false;
      details.querySelector('summary').focus();
    }
    document.querySelectorAll('.c21-nav__details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
    const colour = event.target.closest('[data-c21-colour-link][data-product-handle]');
    if (colour && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const data = JSON.parse(colour.querySelector('[data-c21-variants]').textContent);
      const region = colour.closest('.product-details') || document;
      const fields = [...region.querySelectorAll('variant-picker input[type="radio"]:checked, variant-picker select')];
      const colours = colour.closest('[data-c21-colours]');
      const optionKey = name => /length/i.test(name) ? 'length' : /size/i.test(name) ? 'size' : name.toLowerCase().trim();
      const names = JSON.parse(colours.dataset.optionNames).map(optionKey);
      const values = JSON.parse(colours.dataset.optionValues);
      fields.forEach(field => {
        const name = field.dataset.optionName || field.querySelector('option:checked')?.dataset.optionName;
        const index = names.indexOf(optionKey(name));
        if (index >= 0) values[index] = field.value;
      });
      const chosen = data.options.map(name => values[names.indexOf(optionKey(name))]);
      if (chosen.length) {
        const match = data.variants.find(variant => variant.options.length === chosen.length && variant.options.every((value, i) => value.toLowerCase() === String(chosen[i]).toLowerCase()));
        const destination = new URL(colour.href);
        if (match) { destination.searchParams.set('variant', match.id); destination.searchParams.delete('c21_fit_notice'); }
        else destination.searchParams.set('c21_fit_notice', '1');
        colour.href = destination.toString();
      }
    }

  });
  const mobileMenu = document.querySelector('.c21-nav--mobile > .c21-nav__details');
  mobileMenu?.addEventListener('toggle', () => {
    document.body.classList.toggle('c21-menu-open', mobileMenu.open);
    if (mobileMenu.open) mobileMenu.querySelector('.c21-nav__close')?.focus();
  });
  window.matchMedia('(min-width: 1000px)').addEventListener('change', event => {
    if (event.matches && mobileMenu) mobileMenu.open = false;
  });
  mobileMenu?.addEventListener('click', event => {
    if (event.target.closest('a')) mobileMenu.open = false;
  });
  mobileMenu?.addEventListener('keydown', event => {
    if (!mobileMenu.open || event.key !== 'Tab') return;
    const panel = mobileMenu.querySelector('.c21-nav__panel');
    const items = [...panel.querySelectorAll('a, button, summary')].filter(item => item.getClientRects().length);
    const first = items[0], last = items.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  // The app supplies the login action; make its injected div keyboard accessible.
  const labelLogin = () => {
    const login = document.getElementById('kp-login-button-header-logo');
    if (!login) return;
    login.setAttribute('role', 'button');
    login.setAttribute('tabindex', '0');
    login.setAttribute('aria-label', 'Account');
  };
  labelLogin();
  const header = document.getElementById('header-component');
  if (header) new MutationObserver(labelLogin).observe(header, { childList: true, subtree: true });
  document.addEventListener('keydown', event => {
    if (event.target.id === 'kp-login-button-header-logo' && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      event.target.click();
    }

    if (event.key !== 'Escape') return;
    document.querySelectorAll('.c21-nav__details[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
  });
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    const swatch = event.target.closest('[data-c21-shade]');
    if (swatch) selectShade(swatch);
  });
  if (new URLSearchParams(location.search).has('c21_fit_notice')) document.querySelectorAll('[data-c21-fit-notice]').forEach(item => item.hidden = false);
})();
